import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { ConfiguredCarStaticCatalogDocument, ModelCatalogInput } from '~/graphql/__generated__/graphql';

export function useConfiguredCarStaticCatalog() {
	const [fetchStandardEquipmentData, { data, previousData, loading }] = useLazyQuery(
		ConfiguredCarStaticCatalogDocument,
		{
			returnPartialData: true,
			fetchPolicy: 'no-cache',
		},
	);

	const fetchStandardEquipment = useCallback(
		(input: ModelCatalogInput) => {
			return fetchStandardEquipmentData({
				variables: {
					input,
				},
			});
		},
		[fetchStandardEquipmentData],
	);

	return {
		fetchStandardEquipment,
		selectedStandardEquipment: data ?? previousData,
		isLoading: loading,
	};
}
